import React, { useState, useEffect, useRef } from 'react';
import t from 'prop-types';

function Tirador(_ref) {
  var clase = _ref.clase,
      onEmpezar = _ref.onEmpezar,
      onArrastrando = _ref.onArrastrando,
      onTerminar = _ref.onTerminar;

  var _useState = useState(false),
      arrastrando = _useState[0],
      setArrastrando = _useState[1];

  var anclaRef = useRef(null);
  useEffect(function () {
    if (!arrastrando || !anclaRef.current) {
      return;
    }

    function handleArrastrar(e) {
      window.console.log('handleArrastrar', {
        arrastrando: arrastrando
      });
      var ix = e.clientX - anclaRef.current.x;
      var iy = e.clientY - anclaRef.current.y;
      onArrastrando({
        ix: ix,
        iy: iy
      });
    }

    function handleTerminar(e) {
      window.console.log('handleTerminar', {
        arrastrando: arrastrando
      });

      if (arrastrando) {
        var ix = e.clientX - anclaRef.current.x;
        var iy = e.clientY - anclaRef.current.y;
        onArrastrando({
          ix: ix,
          iy: iy
        });
        setArrastrando(false);
        onTerminar && onTerminar();
      }
    }

    window.addEventListener('mousemove', handleArrastrar);
    window.addEventListener('mouseup', handleTerminar);
    return function () {
      window.removeEventListener('mousemove', handleArrastrar);
      window.removeEventListener('mouseup', handleTerminar);
    };
  }, [arrastrando, anclaRef, onArrastrando, onTerminar]);

  function handleEmpezar(e) {
    window.console.log('handleEmpezar');
    anclaRef.current = {
      x: e.clientX,
      y: e.clientY
    };
    setArrastrando(true);
    onEmpezar && onEmpezar();
  } // const estiloFinal = {
  //     position: 'absolute',
  //     backgroundColor: arrastrando ? 'red' : 'grey',
  //     cursor: 'pointer',
  //     ...style
  // }


  return React.createElement('div', {
    className: clase // style={ estiloFinal }
    ,
    style: {
      position: 'absolute'
    },
    onMouseDown: handleEmpezar
  });
}

Tirador.propTypes = process.env.NODE_ENV !== "production" ? {
  clase: t.string,
  style: t.object,
  onEmpezar: t.func,
  onArrastrando: t.func,
  onTerminar: t.func
} : {};
export default Tirador;